import { columnsValueBatter, columnsValuePitcher, columnsValueBattingTeam, columnsValuePitchingTeam } from "./value";
import { columnsSituationalBatter, columnsSituationalPitcher, columnsSituationalBattingTeam, columnsSituationalPitchingTeam } from "./situational";
import { columnsSplitsBatter, columnsSplitsPitcher, columnsSplitsBattingTeam, columnsSplitsPitchingTeam } from "./splits";
import { columnsBaserunningPlayer, columnsBaserunningTeam } from "./baserunning";
import { columnsBattedBallBatter, columnsBattedBallPitcher, columnsBattedBallBattingTeam, columnsBattedBallPitchingTeam } from "./battedBall";

export { columnsValueBatter, columnsValuePitcher, columnsValueBattingTeam, columnsValuePitchingTeam } from "./value";
export { columnsSituationalBatter, columnsSituationalPitcher, columnsSituationalBattingTeam, columnsSituationalPitchingTeam } from "./situational";
export { columnsSplitsBatter, columnsSplitsPitcher, columnsSplitsBattingTeam, columnsSplitsPitchingTeam } from "./splits";
export { columnsBaserunningPlayer, columnsBaserunningTeam } from "./baserunning";
export { columnsBattedBallBatter, columnsBattedBallPitcher, columnsBattedBallBattingTeam, columnsBattedBallPitchingTeam } from "./battedBall";

const COLUMN_MAP = {
  value: {
    player: { batter: columnsValueBatter, pitcher: columnsValuePitcher },
    team: { batter: columnsValueBattingTeam, pitcher: columnsValuePitchingTeam },
  },
  situational: {
    player: { batter: columnsSituationalBatter, pitcher: columnsSituationalPitcher },
    team: { batter: columnsSituationalBattingTeam, pitcher: columnsSituationalPitchingTeam },
  },
  splits: {
    player: { batter: columnsSplitsBatter, pitcher: columnsSplitsPitcher },
    team: { batter: columnsSplitsBattingTeam, pitcher: columnsSplitsPitchingTeam },
  },
  baserunning: {
    player: columnsBaserunningPlayer,
    team: columnsBaserunningTeam,
  },
  battedball: {
    player: { batter: columnsBattedBallBatter, pitcher: columnsBattedBallPitcher },
    team: { batter: columnsBattedBallBattingTeam, pitcher: columnsBattedBallPitchingTeam },
  },
};

export const getLeaderboardColumns = (type, playerType, viewLevel) => {
  const config = COLUMN_MAP[type];
  if (!config) return columnsValueBatter;
  const level = config[viewLevel] || config.player;
  if (Array.isArray(level)) return level;
  return level[playerType] || level.batter;
};
